import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customerPointSettingQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { CustomerPointSettingListResponse } from '@/services/pointConfiguration/pointConfiguration.types';
import { useSearch } from '@tanstack/react-router';

export const useCustomerPointSettingList = () => {
  const search = useSearch({ from: '/(app)/points-management/points-configuration/' });
  const dates = parseDateRangeSearch(search.createdDate, { start: 0, end: 0 });
  const params = {
    row: search.page,
    fetch: search.fetch,
    search: search.q ?? '',
    fromDate: dates?.start ?? 0,
    toDate: dates?.end ?? 0,
  };
  const { data, isLoading } = useQuery<PaginatedApiResponse<CustomerPointSettingListResponse[]>>({
    ...customerPointSettingQueries.list(params),
    select: (res) => ({ ...res, data: sortBy(res.data, search.sort) }),
  });
  return { categories: data?.data ?? [], isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};
